import { timeFormat } from 'd3-time-format';
import { formatTickValue } from '../displayFormatService';

export const bandTicks = (scale, data, dimensionKey, width, useShortLabel) => {
  return data.map(d => {
    return {
      position: scale(d[dimensionKey]) + (width) / 2,
      label: useShortLabel && d[dimensionKey] && d[dimensionKey].length > 7
        ? d[dimensionKey].slice(0, 7) + '...'
        : d[dimensionKey],
    };
  });
};

export const timeSeriesTicks = (scale, data) => {
  const numberOfTicks = Math.min(data.length, 6);
  const ticks = scale.ticks(numberOfTicks);

  return ticks.map(t => {
    return {
      position: scale(t),
      label: timeFormat('%b %d')(t),
    };
  });
};

export const linearTicks = (
  scale,
  interval,
  chartMax,
  isInPercentages=false,
) => {
  const ticks = scale.ticks(chartMax / interval);

  return ticks.map(tick => {
    return {
      position: scale(tick),
      label: formatTickValue(tick, isInPercentages),
    };
  });
};
